import axios from 'axios';

const REFUND_RULES_API_URL = 'catalog/api/v1/refundRules';

export function getRefundRules(departureFlight, returnFlight, passengers) {
  return new Promise((resolve, reject) => {
    const payload = createGetRefundRulesRequestPayload(departureFlight, returnFlight, passengers);
    axios
      .post(REFUND_RULES_API_URL, payload)
      .then(res => resolve(res))
      .catch(err => {
        reject(err);
      });
  });
}

function getFlightsGroups(flightGroups, fare) {
  return flightGroups.map(element => {
    let flightFare = fare[element.flightNumber.toString()];
    return {
      departureDate: element.departureDate,
      departureTime: element.departureTime,
      arrivalDate: element.arrivalDate,
      arrivalTime: element.arrivalTime,
      destination: element.destination,
      flightNumber: element.flightNumber,
      marketingCarrier: element.marketingCarrier,
      operatingCarrier: element.operatingCarrier,
      origin: element.origin,
      classOfService: flightFare.classOfService,
      throughFlight: element.throughFlight
    };
  });
}

function createGetRefundRulesRequestPayload(
  departureFlightParam,
  returnFlightParam,
  passengersParam
) {
  let payload = {};

  const fare = obtainFare(
    departureFlightParam.flight,
    returnFlightParam ? returnFlightParam.flight : null,
    departureFlightParam.category,
    returnFlightParam ? returnFlightParam.category : null
  );

  let departureFare, returnFare;

  if (fare && returnFlightParam) {
    departureFare = fare['departure'];
    returnFare = fare['return'];
  } else {
    departureFare = fare;
  }

  payload.departureFlight = {
    flightGroup: getFlightsGroups(departureFlightParam.flight.flightGroup, departureFare)
  };

  if (returnFlightParam != null) {
    payload.returnFlight = {
      flightGroup: getFlightsGroups(returnFlightParam.flight.flightGroup, returnFare)
    };
  }
  payload.passengers = {
    ADT: parseInt(passengersParam.adultNumber, 10),
    CNN: parseInt(passengersParam.childNumber, 10),
    INF: parseInt(passengersParam.infantNumber, 10)
  };

  payload.fareOriginType = departureFlightParam.flight.fareOriginType.toUpperCase() == "AWARD" ? "AWARD" : "PUBLIC" ;

  payload.isPointsPlusMoney= obtainPointsPlusMoney(departureFlightParam, returnFlightParam ? returnFlightParam : null);

  return payload;
}

function obtainFare(departureFlight, returnFlight, departureCategory, returnCategory) {
  let fare = null;

  if (returnFlight) {
    fare = returnFlight.fare[returnCategory];
  } else {
    let recommendationCategory = departureFlight.recommendations.filter(
      recommendation =>
        recommendation.departureCategory.toUpperCase() === departureCategory.toUpperCase()
    );
    fare = recommendationCategory[0].fare;
  }
  return fare;
}

function obtainPointsPlusMoney(departureFlight, returnFlight) {
  let pointsPlusMoneyDeparture;
  let pointsPlusMoneyReturn;

  departureFlight.rangePointsPlusMoney ? pointsPlusMoneyDeparture = true : pointsPlusMoneyDeparture = false;
  returnFlight ? returnFlight.rangePointsPlusMoney ? pointsPlusMoneyReturn = true : pointsPlusMoneyReturn = false : pointsPlusMoneyReturn = false;


  return pointsPlusMoneyDeparture || pointsPlusMoneyReturn;
}



// WEBPACK FOOTER //
// ./src/services/refundRules/RefundRulesService.js